export default __webpack_public_path__ + "static/media/ic_xvs_24.0298002b.svg";